<template>
  <v-combobox
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="approvalApprovers"
    :item-text="render"
    clearable
    return-object
  />
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ApprovalApproverField",
  props: {
    value: Object,
    showKey: {
      type: Boolean,
      default: false,
      required: false
    },
    approvalType: {
      type: Object
    }
  },
  data: () => ({
    approvalApprovers: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    },
    render(item) {
      let response = item?.fullName;
      if (this.showKey) {
        response = `${item?.participantKey} - ${response}`;
      }
      return response;
    }
  },
  mounted() {
    if (!this.approvalType) {
      console.log("No approval type provided to retrieve approvers");
      return;
    }
    ApiService.get("/api/approvalApprovers/byApprovalTypeId/" + this.approvalType.id).then(({ data }) => {
      this.approvalApprovers = data.map(a => a.participant);
    });
  }
};
</script>
